/* eslint-disable react/prop-types */
import React from 'react';
import { Icon } from '@fiverr-private/fit';
import { s_heart, s_comment } from '@fiverr-private/icons';
import { white } from '@fiverr-private/sass/helpers/index';
import { default as MediaAsset } from '@fiverr-private/cms_ui/src/content_types/MediaAsset/component/MediaAsset';

import './styles.scss';

export const Item = (props) => {
    const [likes, comments] = props.previewUrl?.split('/') || [0, 0];

    return (
        <div className="list-grid-item">
            <div className="image-wrapper">
                <MediaAsset {...props} />
                <div className="social-icons tbody-5 text-bold">
                    <span>
                        <Icon color={white}>{s_heart}</Icon>
                        {likes}
                    </span>
                    <span>
                        <Icon color={white}>{s_comment}</Icon>
                        {comments}
                    </span>
                </div>
            </div>
        </div>
    );
};
